<template>
    <div id="visuals">
        <div class="page-inner-wrapper position-relative white-bg">
            <div class="position-relative page-header bg-img-atr-fix ">
                <div class="position-absolute overlay overlay-bg-lightdark">
                    <div class="d-flex flex-row align-items-center justify-content-center">
                        <h1 class="white-color" v-scrollanimation>{{dataText.title}}</h1>
                    </div>
                </div>
            </div>
            <div class="module-space">
                <div class="container-fluid">
                    <div class="col-sm-12 module-space position-relative" style=" padding-top: 0;">
                        <div class="column-inner">
                            <div class="wrapper">
                                <div class="module-text-container p-text text-justify">
                                    <p v-scrollanimation>{{dataText.p1}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 position-relative bg-img-atr v-bg01">
                        <div class="overlay position-absolute visual-yt-overlay"></div>
                        <div class="column-inner position-relative" style="z-index: 5;">
                            <div class="wrapper">
                                <div class="module-text-container p-text text-justify">
                                    <p class="white-color left" v-scrollanimation>{{dataText.t1}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="col-lg-12">
                    <div class="chess-table">
                        <div class="d-table-cell v-bg02 bg-img-atr left" v-scrollanimation></div>
                        <div class="d-table-cell chess-table-textbox textbox-right p-text text-justify right" v-scrollanimation>
                            <p class="pre-formatted">{{dataText.t2}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="module-space">
                <div class="container-fluid">
                    <div class="col-sm-12 position-relative bg-img-atr v-bg03">
                        <div class="overlay position-absolute visual-story-overlay"></div>
                        <div class="column-inner position-relative" style="z-index: 5;">
                            <div class="wrapper">
                                <div class="module-text-container p-text text-justify">
                                    <p class="white-color right" v-scrollanimation>{{dataText.t3}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Footer from '../components/Footer'

    export default {
        name: "Visuals",
        props: {
            webData: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                dataText: this.webData.services.visual
            }
        },
        components: {
            Footer
        }
    }
</script>

<style scoped>
    #visuals .page-header {
        background-image: url("../assets/photos/h3_visual_header_bg.jpg");
    }
    #visuals .page-header .overlay .d-flex {
        height: 100%;
    }
    #visuals .page-inner-wrapper .module-space .container-fluid {
        padding: 0;
    }
    .v-bg01 {
        background-image: url("../assets/photos/v_img_bg01.jpg");
    }
    .v-bg02 {
        background-image: url("../assets/photos/v_img_bg02.jpg");
        height: 530px;
    }
    .v-bg03 {
        background-image: url("../assets/photos/v_img_bg03.jpg");
    }
    .visual-yt-overlay {
        background-image: linear-gradient(90deg, rgba(160, 81, 101, .824), rgba(98, 127, 157, .824));
        z-index: 1;
    }
    .visual-story-overlay {
        background-image: linear-gradient(90deg, rgba(188, 170, 24, .724), rgba(0, 0, 0, .824));
        z-index: 1;
    }
    .module-text-container {
        padding: 50px 25px;
    }
    .p-text p {
        margin-bottom: 0;
    }

</style>